"use strict";
var typeahead_directive_1 = require('./typeahead/typeahead.directive');
var typeahead_container_component_1 = require('./typeahead/typeahead-container.component');
var typeahead_directive_2 = require('./typeahead/typeahead.directive');
exports.TypeaheadDirective = typeahead_directive_2.TypeaheadDirective;
var typeahead_container_component_2 = require('./typeahead/typeahead-container.component');
exports.TypeaheadContainerComponent = typeahead_container_component_2.TypeaheadContainerComponent;
var typeahead_options_class_1 = require('./typeahead/typeahead-options.class');
exports.TypeaheadOptions = typeahead_options_class_1.TypeaheadOptions;
exports.TYPEAHEAD_DIRECTIVES = [typeahead_directive_1.TypeaheadDirective, typeahead_container_component_1.TypeaheadContainerComponent];



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-bootstrap/components/typeahead.js
 ** module id = 838
 ** module chunks = 0
 **/